export const ty = 2023

